import { render } from "./component-receiver-korr-acc.vue?vue&type=template&id=40a8f019"
import script from "./component-receiver-korr-acc.vue?vue&type=script&setup=true&lang=js"
export * from "./component-receiver-korr-acc.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-receiver-korr-acc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40a8f019"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40a8f019', __exports__)) {
    api.reload('40a8f019', __exports__)
  }
  
  module.hot.accept("./component-receiver-korr-acc.vue?vue&type=template&id=40a8f019", () => {
    api.rerender('40a8f019', render)
  })

}


export default __exports__